var DistanceUnit = /* @__PURE__ */ ((DistanceUnit2) => {
  DistanceUnit2["km"] = "km";
  DistanceUnit2["meter"] = "meter";
  DistanceUnit2["mile"] = "mile";
  return DistanceUnit2;
})(DistanceUnit || {});
export {
  DistanceUnit
};
//# sourceMappingURL=utils.js.map
